import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { pathToMessagesPM } from 'Utils/nav/NavHelpers';
import { resetMessages } from 'Actions/MessagesviewActions';
import messagesSelector from 'Selectors/messagesSelector';
import MessagePreview from 'Components/messages/MessagePreviewComponent';
import { resetSelectedItem } from 'Actions/MetaActions';

class MessagesPreviewListComponent extends React.Component {
	componentDidMount() {
		this.props.dispatch( resetSelectedItem() );
	}

	goToPm = ( event ) => {
		let pmId = event.currentTarget.dataset.pmid,
			page = event.currentTarget.dataset.page;

		if( isFinite( parseInt( pmId ) ) ) {
			this.props.dispatch( resetMessages() );
			let pmLocation = {
				pathname: pathToMessagesPM( pmId ),
				query: { frompage: page || 1 }
			};
			this.props.dispatch( push( pmLocation ) );
		}
	};

	buildMessage( msg, i, pageNum ) {
		const { entities } = this.props.messagesview;
		let className = "pmpreview " + ( msg.unread ? 'unread' : '' );

		return (
			<li className={ className } id={ `pmpreview_${ msg.id }` } key={`pmpreview_${ msg.id }`} data-pmid={ msg.id } data-page={ pageNum } onClick={ this.goToPm }>
				<MessagePreview key={ msg.id } pm={ msg } users={ entities.users } selectedElements={ this.props.meta.selectedElements } dispatch={ this.props.dispatch } />
			</li>
		);
	}

	buildPage = ( pageNum ) => {
		const { entities, result } = this.props.messagesview;

		let pms = result.pms.filter( e => entities.pms[ e ] && entities.pms[ e ].page === pageNum ),
			pmList = pms.map( ( id, i ) => this.buildMessage( entities.pms[ id ], i, pageNum ) );

		return (
			<ul key={pageNum} id={ `message_page_${pageNum}` } className={`alert scroll_page page_${pageNum}`}>
				{ pmList }
			</ul>
		)
	};

	render() {
		const { result } = this.props.messagesview;

		if( result.pms.length === 0 ) {
			return null;
		}

		let messagesListPage = this.props.pages.map( ( pageNum, index ) => this.buildPage( pageNum, index ) );

		return (
			<div className="messagesRoot messagesContainer" ref={ this.props.listRef } >
				{ messagesListPage  }
			</div>
		);
	}
}

MessagesPreviewListComponent.propTypes = {
	dispatch: PropTypes.func.isRequired,
	pages: PropTypes.array.isRequired,
};

export default connect( messagesSelector )( MessagesPreviewListComponent );


// WEBPACK FOOTER //
// ./src/components/messages/MessagesPreviewListComponent.js